export const ProductEndpoints = {
    updateFreeSignup: (subdomain) => {
        return `${process.env.API_CONTENT_PLATFORM_SPACE_GATEWAY}/rest/v1/memberships/${subdomain}/freesignup/sales`;
    },
    getFreeSignupStatus: () => {
        return `${process.env.API_CLUB_SETTINGS}/v4/membership/signup-allowed`;
    },
    getOffer: (productId) => {
        return `${process.env.API_CONTENT_PLATFORM_SPACE_GATEWAY}/rest/v1/admin/products/${productId}/offer`;
    }
};
